import { FC } from "react"
import { GuardianFormFieldType } from "../../../../models/api-models/guardians/guardian-form"
import React from "react";

interface FormFieldDescription {
    valueType: GuardianFormFieldType,
    description: string
}

const cleanHTML = (html: string): string => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    doc.querySelectorAll('script').forEach(script => script.remove());
    return doc.body.innerHTML;
};

export const FormFieldDescription: FC<FormFieldDescription> = ({valueType, description}) => {

    if (valueType === GuardianFormFieldType.TextArea) {
        const sanitizedHTML = cleanHTML(description);
        return <div className="field-name-description" dangerouslySetInnerHTML={{ __html: sanitizedHTML }} />;
    }
    return <p className="field-name-description">{description}</p>;
}